export default __webpack_public_path__ + "static/media/alarm.df341cf0.svg";